import { createSelector } from 'reselect'

import { getAnalytics } from './rootSelectors'
import { getSearchFilters } from './searchSelectors'

export const getAnalyticsTags = createSelector(getAnalytics, (analyticsState) => analyticsState.list)

export const isAnalyticsSelected = (tagId: number) =>
  createSelector(getSearchFilters, (filters) => !!filters[`tag:${tagId}`])
